import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { IRootState } from './types';
import { reducers } from './reducers';

const initialState: IRootState = {
  tasklists: [],
  dailySubmissions: [],
  selectedTasklist: {} as IRootState['selectedTasklist'],
  selectedTasklistForAction: {} as IRootState['selectedTasklistForAction'],
  isOpenDeleteDialog: false,
  submissions: {} as IRootState['submissions'],
  submittedTasklists: [],
  selectedSubmission: {} as IRootState['selectedSubmission'],
  formattedSubmissions: [],
  selectedDailySubmission: {} as IRootState['selectedDailySubmission'],
  selectedTasklistToSubmit: {} as IRootState['selectedTasklistToSubmit'],
  tab: '1',
  isOpenAllTasklistsNav: false,
  isOpenAllSubmissionsNav: false,
  tasklistSelectedLocationId: 0,
};

export const slice = createSlice({
  name: STORE_SLICES.TASKLISTS,
  initialState,
  reducers,
});

const tasklistsActions = slice.actions;

const tasklistsPersistConfig = {
  key: PERSIST_KEYS.TASKLISTS,
  storage,
  blacklist: ['isOpenDeleteDialog'],
};

export {
  tasklistsActions,
};

export default persistReducer(tasklistsPersistConfig, slice.reducer);
